import React from 'react';
import {connect} from "react-redux";
import ProjetProTable from './comps/ProjetProTable';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import {AutoCompleteValidator, TextValidator, ValidatorForm} from 'react-material-ui-form-validator';
import Autocomplete from 'material-ui/AutoComplete'
import MenuItem from 'material-ui/MenuItem';
import AddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import {
    getActivitesPrincipales,
    getCompetences,
    getPointsAmelioration,
    getProjetsPro
} from "../../../../../actions/entreprise/actions_entreprise_entretien";
import moment from "../../../../shared/utils/moment_fr";
import CustomDatePicker from './../../../../shared/utils/CustomDatePicker';
import AuthService from './../../../../../services/AuthService';
import Alert from "../../../../shared/utils/Alert";


class Page5 extends React.Component {

    constructor(props) {
        super(props);
        this.initialFormValues = {
            modalOpen: false,
            projet_pro_defini: '',
            id_echeance_du_projet: '',
            domaine_activite_visee: '',
            competences_a_developper: '',
            moyens_a_mobiliser: '',
            type_validation: '',
            precision: '',
            Date_debut: new Date().toISOString().substring(0, 10),
            Date_fin: new Date().toISOString().substring(0, 10)
        };
        this.state = {
            ...this.initialFormValues,
            modalOpen: false,
            salarie_exprime_p_pro: ""
        };
        this.Auth = new AuthService();
        this.selectedMoyen = null;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.fetchPProExprime = this.fetchPProExprime.bind(this);
    }

    resetForm() {
        this.setState(this.initialFormValues);
    }

    fetchPProExprime(eh) {
        this.Auth.fetch(`/salarie/${eh.id_salarie}/projet_pro_exprime`)
            .then(x => this.setState({salarie_exprime_p_pro: x.data.payload}));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.entretienHeader !== this.props.entretienHeader) {
            let eh = this.props.entretienHeader;
            this.props.dispatch(getPointsAmelioration(eh.id));
            this.props.dispatch(getActivitesPrincipales(eh.id));
            this.props.dispatch(getCompetences(eh.id));
            this.fetchPProExprime(eh);
        }
    }

    componentDidMount() {
        let eh = this.props.entretienHeader;
        this.fetchPProExprime(eh);
    }

    handleSubmit() {
        if (moment(this.state.Date_debut).isAfter(moment(this.state.Date_fin))) {
            window.alert('Date début ne peut pas être après date fin.');
        } else {
            let toPersist = this.state;
            if (this.selectedMoyen && this.selectedMoyen.needs_details === "1") {
                if (toPersist.type_validation !== '' || toPersist.precision !== '') {
                    toPersist.moyens_a_mobiliser = toPersist.moyens_a_mobiliser
                        + '<br>'
                        + toPersist.type_validation + '<br>' + toPersist.precision;
                }
            }
            toPersist.id_entretien = this.props.entretienHeader.id;
            toPersist.id_salarie = this.props.entretienHeader.id_salarie;
            this.Auth.fetch('/salarie/projet_pro', {
                method: 'post',
                data: toPersist
            }).then(x => {
                this.props.dispatch(getProjetsPro(this.props.entretienHeader.id));
                this.resetForm();
                this.setState({modalOpen: false});
            })
        }
    }

    handleChange(event, value) {
        let obj = {};
        obj[event.target.name] = value;
        this.setState(obj);
    }


    render() {
        this.selectedMoyen = this.props.params_moyens_a_mobiliser
            .filter(x => x.moyen === this.state.moyens_a_mobiliser).length > 0 ?
            this.props.params_moyens_a_mobiliser
                .filter(x => x.moyen === this.state.moyens_a_mobiliser)[0] : null;
        return (
            <div>
                <div className={'row justify-content-md-center'}>
                    <div className='col col-sm-10'>
                        <Alert text="Veuillez décrire le projet envisagé pour le salarié."/>

                        {this.state.salarie_exprime_p_pro &&
                        <p className='text-white bg-dark' style={{fontSize: 12, padding: 10}}>
                            <span
                                className='text-warning'>Le salarié a exprimé son projet sur son espace personnel :<br/></span>
                            {this.state.salarie_exprime_p_pro}
                        </p>}
                        <ProjetProTable/>
                        <RaisedButton
                            label="Ajouter un projet"
                            style={{marginTop: 15}}
                            onClick={() => this.setState({modalOpen: true})}
                            secondary={true}
                            icon={<AddIcon/>}
                        />
                        <Dialog
                            title="Projet professionnel"
                            modal={false}
                            open={this.state.modalOpen}
                            onRequestClose={() => this.setState({...this.initialFormValues, modalOpen: false})}
                            autoScrollBodyContent={true}
                            contentStyle={{
                                width: '100%',
                                maxWidth: 'none',
                            }}
                        >
                            <ValidatorForm
                                ref="form"
                                onSubmit={this.handleSubmit}
                            >
                                <AutoCompleteValidator
                                    value={this.state.projet_pro_defini}
                                    hintText="Projet professionnel défini"
                                    floatingLabelText="Projet professionnel défini"
                                    filter={Autocomplete.caseInsensitiveFilter}
                                    dataSource={this.props.points_amelioration.map(x => x.point_amelioration)}
                                    name={'projet_pro_defini'}
                                    onUpdateInput={(x) => this.handleChange({target: {name: 'projet_pro_defini'}}, x)}
                                    fullWidth={true}
                                    maxSearchResults={5}
                                    validators={['required', 'trim']}
                                    errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                                />
                                <SelectField
                                    value={this.state.id_echeance_du_projet}
                                    fullWidth={true}
                                    floatingLabelText="Échéance du projet"
                                    onChange={(x, y, z) => this.handleChange({target: {name: 'id_echeance_du_projet'}}, z)}
                                    maxHeight={400}
                                >
                                    {this.props.params_echeances.map(x => <MenuItem key={x.id} value={x.id}
                                                                                    primaryText={x.echeance}/>)}
                                </SelectField>
                                <AutoCompleteValidator
                                    value={this.state.domaine_activite_visee}
                                    hintText="Domaine d'activité visé"
                                    floatingLabelText="Domaine d'activité visé"
                                    name={'domaine_activite_visee'}
                                    filter={Autocomplete.caseInsensitiveFilter}
                                    dataSource={this.props.activites_principales.map(x => x.activite)}
                                    onUpdateInput={(x) => this.handleChange({target: {name: 'domaine_activite_visee'}}, x)}
                                    fullWidth={true}
                                    maxSearchResults={5}
                                    validators={['required', 'trim']}
                                    errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                                />
                                <AutoCompleteValidator
                                    value={this.state.competences_a_developper}
                                    hintText="Compétence à développer"
                                    floatingLabelText="Compétence à développer"
                                    name={'competences_a_developper'}
                                    filter={Autocomplete.caseInsensitiveFilter}
                                    dataSource={this.props.competences.map(x => x.competence)}
                                    onUpdateInput={(x) => this.handleChange({target: {name: 'competences_a_developper'}}, x)}
                                    fullWidth={true}
                                    maxSearchResults={5}
                                    validators={['required', 'trim']}
                                    errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                                />
                                <SelectField
                                    value={this.state.moyens_a_mobiliser}
                                    fullWidth={true}
                                    floatingLabelText="Moyens à mobiliser"
                                    onChange={(x, y, z) => this.handleChange({target: {name: 'moyens_a_mobiliser'}}, z)}
                                    maxHeight={400}
                                >
                                    {this.props.params_moyens_a_mobiliser.map(x => <MenuItem key={x.id} value={x.moyen}
                                                                                             primaryText={x.moyen}/>)}
                                </SelectField>
                                {
                                    this.selectedMoyen && this.selectedMoyen.needs_details === "1" && (
                                        <div>
                                            <SelectField
                                                value={this.state.type_validation}
                                                fullWidth={true}
                                                floatingLabelText="Type de validation"
                                                onChange={(x, y, z) => this.handleChange({target: {name: 'type_validation'}}, z)}
                                                maxHeight={400}
                                            >
                                                {this.props.params_types_validation_formation.map(x => <MenuItem
                                                    key={x.id} value={x.type} primaryText={x.type}/>)}
                                            </SelectField>
                                            <TextValidator
                                                value={this.state.precision}
                                                onChange={this.handleChange}
                                                fullWidth={true}
                                                name='precision'
                                                type="text"
                                                floatingLabelText="Précision"
                                            />
                                        </div>
                                    )
                                }
                                <div className={'row'}>
                                    <div className={'col'}>
                                        <CustomDatePicker
                                            floatingLabelText="Date de début du projet"
                                            stringValue={this.state.Date_debut}
                                            onChange={(x, y) => this.handleChange({target: {name: 'Date_debut'}}, moment(y).format("YYYY-MM-DD"))}
                                        />
                                    </div>
                                    <div className={'col'}>
                                        <CustomDatePicker
                                            floatingLabelText="Date de fin du projet"
                                            stringValue={this.state.Date_fin}
                                            onChange={(x, y) => this.handleChange({target: {name: 'Date_fin'}}, moment(y).format("YYYY-MM-DD"))}
                                        />
                                    </div>
                                </div>
                                <RaisedButton
                                    style={{marginTop: 25}}
                                    secondary={true}
                                    label={'Ajouter'}
                                    type={'submit'}/>
                            </ValidatorForm>
                        </Dialog>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        entretienHeader: store.entretien.header,
        params_echeances: store.params.echeances,
        params_moyens_a_mobiliser: store.params.moyens_a_mobiliser,
        params_types_validation_formation: store.params.types_validation_formation,
        points_amelioration: store.entretien.points_amelioration,
        activites_principales: store.entretien.activites_principales,
        competences: store.entretien.competences
    }
}

export default connect(mapStateToProps)(Page5);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/Page5.js